var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0064FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4849 19.8231C14.2716 19.8231 14.0689 19.7377 13.9196 19.5884L10.9009 16.5697C10.5916 16.2604 10.5916 15.7484 10.9009 15.4391C11.2103 15.1297 11.7223 15.1297 12.0316 15.4391L14.4849 17.8924L19.9676 12.4097C20.2769 12.1004 20.7889 12.1004 21.0983 12.4097C21.4076 12.7191 21.4076 13.2311 21.0983 13.5404L15.0503 19.5884C14.9009 19.7377 14.6983 19.8231 14.4849 19.8231Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blue-check.b03eef8693dac9609f100d03a11ddb0b.svg";